import { render, staticRenderFns } from "./CityDistrict.vue?vue&type=template&id=180e561e&"
import script from "./CityDistrict.vue?vue&type=script&lang=js&"
export * from "./CityDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports